import type { IProperty } from "types/jsonSchema";

export const isType = (type: string | string[], value: string) => {
    if (Array.isArray(type)) {
        return type.includes(value);
    }

    return type === value;
};

export const isEnum = (field: IProperty) => field?.enum && field.enum.length > 0;
